/* eslint-disable indent */
import { stringifyUrl } from 'query-string'
import React, { useEffect, useRef, useState } from 'react'

import { useFetch } from './hooks/useFetch'

function decode(str) {
  return str.replace(/\\u([0-9A-F]{4})/g, (match, code) => {
    return String.fromCharCode(parseInt(code, 16));
  });
}

function Filters({ filters, setFilters, selectedFilters }) {
  const renderOptions = (option, index) => {

    if (option.ParentLink?.Label) {
      return (
        <React.Fragment key={`${option.ParentLink.Value}-${index}`}>
          <option
            value={option.ParentLink.Value}
            disabled={option.ParentLink.Disabled ? option.ParentLink.Disabled : false}
          >
            {decode(option.ParentLink.Label)}
          </option>

          {option.Options.map((suboption, index) => (
            <option key={suboption.Value} value={suboption.Value}>
              &nbsp;&nbsp;{decode(suboption.Label)}
            </option>
          ))}
        </React.Fragment>
      )
    } else if (option.Options) {
      return (
        <React.Fragment key={`${option.Options[0].Label.replaceAll(' ', '_')}${index}`}>
          {option.Options.map((suboption) => (
            <option key={suboption.Value} value={suboption.Value}>
              {decode(suboption.Label)}
            </option>
          ))}
        </React.Fragment>
      )
    }

    return (
      <option key={option.Value} value={option.Value}>
        {decode(option.Label)}
      </option>
    )
  }

  return filters?.length ? (
    <div className="news-listing__filters">
      {filters.map((filter) => (
        <select
          className="select"
          aria-label = "select"
          key={filter.Value}
          defaultValue=""
          onChange={(e) =>
            setFilters({
              label: filter.Value,
              value: e.target.value
            })
          }
          value={selectedFilters[filter.Value]}
        >
          {filter.Options?.length &&
            filter.Options.map((option, index) => renderOptions(option, index))}
        </select>
      ))}
    </div>
  ) : null
}

function Listing({ response }) {
  return response ? (
    <section className="news-listing__listing">
      {response.map((item) => (
        <article key={item.Id} className="news-listing__item">
          <div className="news-listing__item-main">
            <time dateTime={item.Date}>{item.Date}</time>
            <h3 className="news-listing__item-heading">
              <a className="link" href={item.Url}>
                {item.Heading}
              </a>
            </h3>
            <p className="news-listing__item-summary">{item.Summary}</p>
          </div>
          {item.Thumbnail ? (
            <img
              className="news-listing__item-thumbnail"
              src={item.Thumbnail}
              alt={item.Heading}
              loading="lazy"
            />
          ) : null}
        </article>
      ))}
    </section>
  ) : null
}

function NewsListing({ endpointUrl, filters: rawFilters, loadMoreLabel, endpointUrlRssFeed, logoAltRssFeed, logoSrcRssFeed, labelRssFeed }) {
  const params = (new URL(document.location)).searchParams;
  const topic = params.get('topic')
  const [filters, setFilters] = useState({})
  const [results, setResults] = useState([])
  const [page, setPage] = useState(1)
  const { current: dropdowns } = useRef(JSON.parse(rawFilters))
  const query = {
    ...filters,
    ...(page && { page })
  }
  const stringifiedUrl = stringifyUrl({ url: endpointUrl, query })
  const { response, error, isLoading } = useFetch(stringifiedUrl)

  function handleFilterChange(filter) {
    setResults([])
    setPage(1)
    setFilters((prev) =>
      Object.fromEntries(
        Object.entries({ ...prev, [filter.label]: filter.value }).filter(([, value]) =>
          Boolean(value)
        )
      )
    )
  }

  function getRssLinks() {
    const RRSFilter = dropdowns.filter((item) => item.Value === 'topic')[0]?.Options;
    const rssLinks = [];
    const defaultOption = RRSFilter?.filter((item) => !item.ParentLink.Value);
    const options = RRSFilter?.filter((item) => item.ParentLink.Value);

    if (defaultOption) {
      defaultOption[0].Options.map((item) => {
        rssLinks.push({ label: item.RssLabel, url: endpointUrlRssFeed });
      });
    }

    if (filters.topic) {
      if (options) {
        options.map((option) => {

          const parentLink = option.ParentLink;
          if (parentLink.Value === filters.topic) {
            rssLinks.push({ label: parentLink.RssLabel, url: `${endpointUrlRssFeed}&topic=${encodeURIComponent(parentLink.Value)}` });
          } else {
            const selectedSubOption = option.Options?.filter((item) => item.Value === filters.topic);
            if (selectedSubOption.length) {
              rssLinks.push({ label: option.ParentLink.RssLabel, url: `${endpointUrlRssFeed}&topic=${encodeURIComponent(option.ParentLink.Value)}` });
              rssLinks.push({ label: selectedSubOption[0]?.RssLabel, url: `${endpointUrlRssFeed}&topic=${encodeURIComponent(selectedSubOption[0]?.Value)}` });
            }
          }
        });
      }
    }

    return (
      <div className='news-listing__rss-feed'>
        <img className='news-listing__rss-feed-logo' src={logoSrcRssFeed} alt={logoAltRssFeed} />
        <h3 className='news-listing__rss-feed-title'>{labelRssFeed}</h3>
        {rssLinks.map((item, index) => {
          return (
            <div key={index} className='news-listing__rss-feed-item'>
              <a href={item.url} className='news-listing__rss-feed-link link' target='_blank' rel='noreferrer'>
                {item.label}
              </a>
            </div>
          );
        })}
      </div>
    )
  }

  function handleFetchMore() {
    setPage((prev) => prev + 1)
  }

  useEffect(() => {
    if (response?.Results) setResults((prev) => [...prev, ...response.Results])
  }, [response])

  useEffect(() => {
    if (topic) {
      setFilters((prev) => ({ ...prev, topic }))
    }
  }, []);

  return (
    <>
      <Filters filters={dropdowns} setFilters={handleFilterChange} selectedFilters={filters}/>
      {getRssLinks()}
      {results?.length ? <Listing response={results} /> : null}
      {page < response?.TotalPages ? (
        <div className="news-listing__actions">
          <button className="btn" disabled={isLoading} onClick={handleFetchMore}>
            {loadMoreLabel}
          </button>
        </div>
      ) : null}
    </>
  )
}

export default NewsListing
